// Funnel events for GA4 — view_item, add_to_cart, begin_checkout — from the
// Peak Labs SPA. Shopify's Google tag runs inside the sandboxed web pixel and
// only sees Shopify's own cart, which the SPA never touches until checkout, so
// without this GA4 has no product views and "add_to_cart" only fires at
// checkout time. Same beacon path as peak-labs-wa-track.js: the tracking worker
// relays to GA4 with the visitor's real _ga ids, so attribution is preserved.
// Loaded before the compiled bundle (all 4 SPA templates), so the hooks below
// are installed before the app assigns its window functions.
(function () {
  var ENDPOINT = "https://peaklabs-tracking.peaklabs.workers.dev/api/ga4-event";
  var CART_KEY = "pl_cart_v1";

  function cookie(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : "";
  }
  function clientId() { var m = cookie("_ga").match(/(\d+\.\d+)$/); return m ? m[1] : ""; }
  function sessionId() { var m = cookie("_ga_KL8B7E84YV").match(/\.s?(\d{9,11})[.$]/); return m ? m[1] : ""; }

  function send(event, extra) {
    var payload = { event: event, cid: clientId(), sid: sessionId(), dl: String(location.href).slice(0, 500) };
    for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k];
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }))) return;
    } catch (e) {}
    try {
      fetch(ENDPOINT, { method: "POST", body: body, keepalive: true, headers: { "Content-Type": "text/plain" } }).catch(function () {});
    } catch (e) {}
  }

  // ---- item shaping -------------------------------------------------------
  // SPA product ids are Shopify handles ("glp3", "glp3::10mg"); the pack format
  // is implied by the handle suffix (-pen / -spray, otherwise vial).
  function format(id) { id = String(id || ""); return /-pen(::|$)/.test(id) ? "Pen" : /-spray(::|$)/.test(id) ? "Spray" : "Vial"; }
  function item(p, qty, dose, variantId, price) {
    p = p || {};
    var d = dose != null ? String(dose) : String(p.dose || "");
    var vid = variantId != null ? variantId : (p.variantId != null ? p.variantId : p.defaultVariantId);
    return {
      id: String(vid || p.handle || p.id || ""),
      name: String(p.name || ""),
      variant: (d ? d + " " : "") + format(p.handle || p.id),
      category: String(p.category || p.cat || ""),
      price: Number(price != null ? price : p.price) || 0,
      qty: qty > 0 ? qty : 1
    };
  }
  function total(items) { var s = 0; for (var i = 0; i < items.length; i++) s += items[i].price * items[i].qty; return Math.round(s * 100) / 100; }
  function findBy(list, key, val) { if (!Array.isArray(list)) return null; for (var i = 0; i < list.length; i++) if (list[i] && String(list[i][key]) === String(val)) return list[i]; return null; }

  // ---- add_to_cart: diff every write of the SPA cart ----------------------
  // The app persists its whole cart ([{product, qty}]) to sessionStorage on
  // every change. Any line whose quantity went up is an add (grid button, PDP,
  // bac-water checkbox, pens, sprays, chat widget — every path funnels here).
  function readCart() {
    try { var raw = sessionStorage.getItem(CART_KEY); var a = raw ? JSON.parse(raw) : []; return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function lineId(l) { return l && l.product ? String(l.product.id || "") : ""; }
  var prev = readCart();
  function onCartWrite(raw) {
    var next; try { next = JSON.parse(raw); } catch (e) { return; }
    if (!Array.isArray(next)) return;
    var before = {};
    for (var i = 0; i < prev.length; i++) { var id0 = lineId(prev[i]); if (id0) before[id0] = (before[id0] || 0) + (Number(prev[i].qty) || 0); }
    var added = [];
    for (var j = 0; j < next.length; j++) {
      var l = next[j], id = lineId(l); if (!id) continue;
      var delta = (Number(l.qty) || 0) - (before[id] || 0);
      if (delta > 0) added.push(item(l.product, delta));
    }
    prev = next;
    if (added.length) send("add_to_cart", { items: added, value: total(added) });
  }
  try {
    var proto = Object.getPrototypeOf(window.sessionStorage), origSet = proto.setItem;
    proto.setItem = function (k, v) {
      var r = origSet.apply(this, arguments);
      if (this === window.sessionStorage && k === CART_KEY) { try { onCartWrite(String(v)); } catch (e) {} }
      return r;
    };
  } catch (e) {}

  // ---- begin_checkout: wrap the app's two checkout entry points ------------
  // The app (re)assigns these on window; an accessor keeps the latest real
  // function and hands back a wrapper that reports first, then delegates.
  function trap(name, before) {
    var real = window[name];
    function wrapped() { try { before.apply(null, arguments); } catch (e) {} return real.apply(this, arguments); }
    try {
      Object.defineProperty(window, name, {
        configurable: true, enumerable: true,
        get: function () { return real ? wrapped : undefined; },
        set: function (v) { real = v; }
      });
    } catch (e) {}
  }
  function cartItems(lines) {
    var out = [];
    for (var i = 0; i < (lines || []).length; i++) {
      var l = lines[i];
      if (l && l.product && l.product.variantId && Number(l.qty) > 0) out.push(item(l.product, Number(l.qty)));
    }
    return out;
  }
  // Shopify checkout via cart permalink (the "Checkout" / "Cash on Delivery · Tamara" button).
  trap("submitCartToShopify", function (items) {
    var its = cartItems(items); if (!its.length) return;
    var value = total(its), min = Number(window.PL_MIN_ORDER || 0);
    if (min > 0 && value < min) return; // the app refuses these with a minimum-order message
    send("begin_checkout", { items: its, value: value, method: window.__plStrablSite ? "shopify_cod" : "shopify" });
  });
  // Strabl card / Apple Pay checkout (the "Pay | Card" button).
  trap("__plPayCard", function () {
    var its = cartItems(readCart()); if (!its.length) return;
    send("begin_checkout", { items: its, value: total(its), method: "strabl_card" });
  });

  // ---- view_item from the hash route --------------------------------------
  // #/product/<handle>[/<dose>]  #/pen/<id>[/<dose>]  #/spray/<slug>
  var lastView = "";
  function decode(s) { try { return decodeURIComponent(s); } catch (e) { return s; } }
  function pickVariant(p, dose) {
    var vs = p && p.variants; if (!Array.isArray(vs) || !vs.length) return null;
    return (dose && findBy(vs, "dose", dose)) || vs[0];
  }
  function viewFromRoute() {
    var h = String(location.hash || ""), parts = h.split("/"), slug = parts[2] || "", dose = parts[3] ? decode(parts[3]) : "";
    if (h === lastView) return true;
    var p, v, it = null;
    if (h.indexOf("#/product/") === 0) {
      var cat = window.CATALOGUE || window.SHOPIFY_CATALOGUE;
      if (!Array.isArray(cat) || !cat.length) return false; // app not booted yet
      p = findBy(cat, "id", slug); if (!p) { lastView = h; return true; } // getProduct() would fall back to the first product; don't log a phantom view
      v = pickVariant(p, dose);
      it = item(p, 1, v ? v.dose : dose, v ? v.variantId : p.defaultVariantId, v ? v.price : p.price);
    } else if (h.indexOf("#/pen/") === 0) {
      if (!Array.isArray(window.PENS)) return !!(window.CATALOGUE || window.SHOPIFY_CATALOGUE); // cart/404 bundles have no pens: nothing to log
      p = findBy(window.PENS, "id", slug); if (!p) { lastView = h; return true; }
      v = pickVariant(p, dose);
      it = item(p, 1, v ? v.dose : p.dose, v ? v.variantId : p.variantId, v ? v.price : p.price);
    } else if (h.indexOf("#/spray/") === 0) {
      if (!Array.isArray(window.PL_SPRAYS)) return !!(window.CATALOGUE || window.SHOPIFY_CATALOGUE);
      p = findBy(window.PL_SPRAYS, "id", slug) || findBy(window.PL_SPRAYS, "handle", slug); if (!p) { lastView = h; return true; }
      it = item(p, 1, p.mg ? String(p.mg) : "", p.variantId, p.price);
    } else { lastView = h; return true; }
    lastView = h;
    send("view_item", { items: [it], value: it.price });
    return true;
  }
  // First paint: the catalogue is injected by the template but the app boots
  // after this script, so poll briefly for it; then follow every route change.
  var tries = 0, poll = setInterval(function () { if (viewFromRoute() || ++tries > 60) clearInterval(poll); }, 250);
  window.addEventListener("hashchange", function () { viewFromRoute(); });
})();
